<template>
  <div class="product-nav">
    <div class="product-nav__header">
      {{ $t(titleKey) }}
    </div>
    <div
      v-for="item in items"
      :key="item.labelKey"
      class="product-nav__item"
      @click="$emit('select', item)"
    >
      <div class="product-nav__item-wrapper">
        <div class="product-nav__item-text">
          <span class="product-nav__item-label">{{ $t(item.labelKey) }}</span>
          <span class="product-nav__item-title">{{ $t(item.titleKey) }}</span>
        </div>
        <button
          type="button"
          class="product-nav__item-action"
          @click.stop="$emit('select', item)"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 3l5 5-5 5"
              stroke="#325F80"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [
      {
        labelKey: 'home.cems_subtitle',
        titleKey: 'home.cems_title_full',
      },
      {
        labelKey: 'home.eza_subtitle',
        titleKey: 'home.eza_title_full',
      },
    ],
  },
  titleKey: {
    type: String,
    default: 'home.apps_title',
  },
});

defineEmits(['select']);
</script>

<style scoped lang="scss">
.product-nav {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 6px;
  gap: 4px;
  background: #ffffff;
  border-radius: 6px;
}

.product-nav__header {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #717379;
  align-self: stretch;
}

.product-nav__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #eef2f4;
  border-radius: 8px;
  align-self: stretch;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: #dde6eb;
  }
}

.product-nav__item-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 8px;
  gap: 12px;
  align-self: stretch;
}

.product-nav__item-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.product-nav__item-label {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #7190a6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-nav__item-title {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #2d3032;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-nav__item-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.15s ease;

  &:hover,
  &:focus-visible {
    background-color: #c6d3db;
    outline: none;
  }
}

.product-nav {
  padding: 16px;
}

.product-nav__title {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #2d3032;
  margin-bottom: 16px;
}

.product-nav__cards {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.product-nav__card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  flex: 1;
  background: #ffffff;
  border: 1px solid #e0e3e5;
  border-radius: 8px;
}

.product-nav__card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-nav__card-subtitle {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #7190a6;
}

.product-nav__card-title {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #2d3032;
}

.product-nav__card-description {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #2d3032;
  align-self: stretch;
}

.product-nav__card-tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  align-self: stretch;
}

.product-nav__card-tag {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  background: #eef2f4;
  border-radius: 32px;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #325f80;
  white-space: nowrap;
}

.product-nav__card-btn {
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid #7190a6;
  border-radius: 6px;
  background: transparent;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #7190a6;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover,
  &:focus-visible {
    background-color: #eef2f4;
    outline: none;
  }
}
</style>